/**
 * Radiesthesia zone data and colour helper shared by RadiesthesiaCanvas and the Pendulum page.
 * Kept out of the component file so React Fast Refresh can treat that file as components only.
 */

/** Shared zone data for canvas and page legend */
export const RADIESTHESIA_ZONES = [
  { start: 0, end: 20, coreColor: '#e63a6e', label: 'harmful' },
  { start: 20, end: 40, coreColor: '#e87f3a', label: 'stressful' },
  { start: 40, end: 60, coreColor: '#e8c43a', label: 'neutral' },
  { start: 60, end: 80, coreColor: '#3ac9e8', label: 'beneficial' },
  { start: 80, end: 100, coreColor: '#3ae89a', label: 'optimal' },
] as const;

/** Convert hex color to rgba string */
export function hexToRgba(hex: string, alpha: number): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
